import { useEffect, useState } from "react";
import styles from "./SoundWaveAnimation.module.scss";

const SoundWaveAnimation = ({
  getCurrentInputVolume,
  isRecordingStarted,
  isPaused,
}) => {
  const [currentInputVolume, setCurrentInputVolume] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const volume = getCurrentInputVolume();
      setCurrentInputVolume(volume);
    }, 100);

    return () => clearInterval(interval);
  }, [getCurrentInputVolume]);

  const generateBarHeights = (volume) => {
    if (volume <= 0 || !isRecordingStarted || isPaused)
      return [0.2, 0.2, 0.2, 0.2, 0.2];

    const clamp = (v, min, max) => Math.min(max, Math.max(min, v));
    const base = clamp(volume, 0, 1);

    return Array.from({ length: 5 }, () => {
      const randomFactor = 0.8 + Math.random() * 0.4;
      return clamp(base * randomFactor, 0.2, 1);
    });
  };

  const barHeights = generateBarHeights(currentInputVolume);

  return (
    <div className={styles["audio-visualizer-container"]}>
      <div className={styles["audio-visualizer"]}>
        {barHeights.map((height, i) => (
          <div
            key={i}
            className={`${styles["circle"]} ${
              isRecordingStarted && !isPaused ? styles["bars"] : ""
            }`}
            style={{
              transform: `scaleY(${height})`,
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default SoundWaveAnimation;
